// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"312":"7507f96d","477":"487e7fea","616":"ac6898e5"}[chunkId] + ".chunk.css";
};